import { load } from "@nextgisweb/jsrealm/i18n/catalog";
load("terrain_provider", {"":{"Terrain provider":["Рельеф"],"Encoding":["Кодировка"]}})